import ThemeOptions from "./ThemeOptions";

// eslint-disable-next-line
export default {
  ThemeOptions,
};
